<!-- Should use class instead of style since angular blocks it from entering rgba to prevent xss -->
<div class="__tail"
     [ngClass]="{'__tail--selected': isSelected, '__tail--disconnected': !isSelected && !isOnline}">
</div>
<div class="__content"
     [style.border-radius]="canClose ? '2px 0 0 2px' : '2px'"
     [style.backgroundColor]="isSelected ? '#64C2E6' : isOnline ? 'rgba(105, 115, 124, 0.9)' : 'rgba(105, 115, 124, 0.5)'">
  <ng-content></ng-content>
</div>
<div *ngIf="canClose"
     class="__close-button"
     (click)="onClose()">
  <awair-cross-icon [color]="'#93989D'"
                    [size]="{width: 9, height: 9}"
                    [strokeWidth]="4">
  </awair-cross-icon>
</div>
